const newsletterModal = document.querySelector('.newsletter-modal__form');
const modalOverlay = document.querySelector('.ob-modal-overlay');
const closeButton = document.querySelector('.modal__close-button');
const cupomCode = document.getElementById('ob-cupom-code');
const copyButton = document.getElementById('ob-btn-copy');
const copyMsg = document.querySelector('#ob-copy-message');
const copiedMsgSuccess = document.querySelector('#ob-copy-message--success');
const iconCopy = document.querySelector('#ob-btn-icon--copy');
const iconCopiedSuccess = document.querySelector('#ob-btn-icon--success');

if (newsletterModal) {
	newsletterModal.addEventListener('submit', () => {
		setCookie('popupShowed', 'true', 364);
		sessionStorage.setItem('customerRegistered', 'popup');
	});
}

if (modalOverlay) {
	modalOverlay.addEventListener('click', () => {
		setCookie('popupShowed', 'true', 5);
	});
}

if (closeButton) {
	closeButton.addEventListener('click', () => {
		setCookie('popupShowed', 'true', 5);
	});
}

const setCookie = (cName, cValue, expDays) => {
	const popupCookies = getCookies();

	if(!popupCookies) {
		let date = new Date();
		date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
		const expires = 'expires=' + date.toUTCString();
		document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
	}
};

const getCookies = () => {
	let cookie = {};
	document.cookie.split(';').forEach(function(el) {
		let [key,value] = el.split('=');
		cookie[key.trim()] = value;
	});
	return cookie['popupShowed'];
};

const handleBtnInitialState = () => {
	copyButton.classList.remove('ob-btn-copy--success');
	copyMsg.style.display = 'inline';
	copiedMsgSuccess.style.display = 'none';
	iconCopy.style.display = 'inline-block';
	iconCopiedSuccess.style.display = 'none';
};

const handleBtnCopySuccess = () => {
	copyButton.classList.add('ob-btn-copy--success');
	copyMsg.style.display = 'none';
	copiedMsgSuccess.style.display = 'inline';
	iconCopy.style.display = 'none';
	iconCopiedSuccess.style.display = 'inline-block';
};

const handleCopy = (event) => {
	event.preventDefault();
	const cupomCodeText = cupomCode.innerText;
	navigator.clipboard.writeText(cupomCodeText).then(() => {
		handleBtnCopySuccess();
		setTimeout(handleBtnInitialState, 2000);
	}).catch((error) => {
		return error;
	});
};

if (copyButton) {
	copyButton.onclick = handleCopy;
}
